module.exports = __webpack_public_path__ + "f8117e83f2dfbfc5837a247cfa56cb00.png";